__turbopack_context__.v({
  "arrowIcon": "InterestTableRow-module-scss-module__zg1CgG__arrowIcon",
  "cell": "InterestTableRow-module-scss-module__zg1CgG__cell",
  "isOpened": "InterestTableRow-module-scss-module__zg1CgG__isOpened",
  "rowContainer": "InterestTableRow-module-scss-module__zg1CgG__rowContainer",
  "rowData": "InterestTableRow-module-scss-module__zg1CgG__rowData",
});
